import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AuthService, Profile, SiteUser, Theater } from '../../../services/Auth/auth.service';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { PhoneMaskDirective } from '../../../directives/phone-mask.directive';
import { passwordMatchValidator } from '../../../services/Auth/passwordMatchValidator';
import { MatIconModule } from "@angular/material/icon";
import { PasswordStrengthService } from '../../../services/PasswordStrength/password-strength.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-manage',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatCheckboxModule,
        MatIconModule,
        PhoneMaskDirective,
        RouterLink,
        RouterModule,
    ],
    templateUrl: './manage.component.html',
    styleUrl: './manage.component.scss'
})
export class ManageComponent {
    private fb = inject(FormBuilder);
    registerForm: FormGroup;

    public partInfoOpen: boolean = false
    public partPawwordOpem: boolean = false
    public partSalesOpen: boolean = false
    public salesMatchesUser: boolean = true
    public theatersOpen: boolean = false

    public editIndex: number = -1

    passwordStrength = this.passwordStrengthService.strength;
    strengthLevel = this.passwordStrengthService.getStrengthLevel(this.passwordStrength().score);

    isPasswordVisible: boolean = false
    isPasswordVisible2: boolean = false

    isNextButtonDisabled:boolean = true

    states = [
        { code: 'AL', name: 'Alabama' },
        { code: 'AK', name: 'Alaska' },
        { code: 'AZ', name: 'Arizona' },
        { code: 'AR', name: 'Arkansas' },
        { code: 'CA', name: 'California' },
        { code: 'CO', name: 'Colorado' },
        { code: 'CT', name: 'Connecticut' },
        { code: 'DE', name: 'Delaware' },
        { code: 'DC', name: 'District of Columbia' },
        { code: 'FL', name: 'Florida' },
        { code: 'GA', name: 'Georgia' },
        { code: 'HI', name: 'Hawaii' },
        { code: 'ID', name: 'Idaho' },
        { code: 'IL', name: 'Illinois' },
        { code: 'IN', name: 'Indiana' },
        { code: 'IA', name: 'Iowa' },
        { code: 'KS', name: 'Kansas' },
        { code: 'KY', name: 'Kentucky' },
        { code: 'LA', name: 'Louisiana' },
        { code: 'ME', name: 'Maine' },
        { code: 'MD', name: 'Maryland' },
        { code: 'MA', name: 'Massachusetts' },
        { code: 'MI', name: 'Michigan' },
        { code: 'MN', name: 'Minnesota' },
        { code: 'MS', name: 'Mississippi' },
        { code: 'MO', name: 'Missouri' },
        { code: 'MT', name: 'Montana' },
        { code: 'NE', name: 'Nebraska' },
        { code: 'NV', name: 'Nevada' },
        { code: 'NH', name: 'New Hampshire' },
        { code: 'NJ', name: 'New Jersey' },
        { code: 'NM', name: 'New Mexico' },
        { code: 'NY', name: 'New York' },
        { code: 'NC', name: 'North Carolina' },
        { code: 'ND', name: 'North Dakota' },
        { code: 'OH', name: 'Ohio' },
        { code: 'OK', name: 'Oklahoma' },
        { code: 'OR', name: 'Oregon' },
        { code: 'PA', name: 'Pennsylvania' },
        { code: 'PR', name: 'Puerto Rico' },
        { code: 'RI', name: 'Rhode Island' },
        { code: 'SC', name: 'South Carolina' },
        { code: 'SD', name: 'South Dakota' },
        { code: 'TN', name: 'Tennessee' },
        { code: 'TX', name: 'Texas' },
        { code: 'UT', name: 'Utah' },
        { code: 'VT', name: 'Vermont' },
        { code: 'VA', name: 'Virginia' },
        { code: 'WA', name: 'Washington' },
        { code: 'WV', name: 'West Virginia' },
        { code: 'WI', name: 'Wisconsin' },
        { code: 'WY', name: 'Wyoming' }
    ];


    constructor(
        public authService: AuthService,
        public passwordStrengthService: PasswordStrengthService,
        private snackBar: MatSnackBar,
    ) {
        this.registerForm = this.fb.group({
            user: this.fb.group({
                firstName: [this.authService.profile?.firstName, Validators.required],
                lastName: [this.authService.profile?.lastName, Validators.required],
                phone: [this.authService.profile?.phone, [Validators.required, Validators.pattern(/^\(\d{3}\) \d{3}-\d{4}$/)]],
                email: [this.authService.profile?.email, [Validators.required, Validators.email]],
            }),
            sales: this.fb.group({
                salesMatchesUser: [true],
                firstName: ['', this.salesMatchesUser ? null : Validators.required],
                lastName: ['', this.salesMatchesUser ? null : Validators.required],
                title: ['', this.salesMatchesUser ? null : Validators.required],
                phone: ['', this.salesMatchesUser ? null : [Validators.required, Validators.pattern(/^\(\d{3}\) \d{3}-\d{4}$/)]],
                email: ['', this.salesMatchesUser ? null : [Validators.required, Validators.email]],
            }),
            theaters: this.fb.array([

            ]),
            password: ['', [Validators.required, Validators.minLength(6)]],
            confirmPassword: ['', [Validators.required]]
        }, { validators: passwordMatchValidator });

        this.strengthLevel = this.passwordStrengthService.getStrengthLevel(this.passwordStrength().score);
    }

    initValues() {
        this.registerForm = this.fb.group({
            user: this.fb.group({
                firstName: [this.authService.profile?.firstName, Validators.required],
                lastName: [this.authService.profile?.lastName, Validators.required],
                phone: [this.authService.profile?.phone, [Validators.required, Validators.pattern(/^\(\d{3}\) \d{3}-\d{4}$/)]],
                email: [this.authService.profile?.email, [Validators.required, Validators.email]],
            }),
            sales: this.fb.group({
                salesMatchesUser: [true],
                firstName: [this.authService.profile?.salesFirstName, this.salesMatchesUser ? null : Validators.required],
                lastName: [this.authService.profile?.salesLastName, this.salesMatchesUser ? null : Validators.required],
                title: [this.authService.profile?.salesTitle, this.salesMatchesUser ? null : Validators.required],
                phone: [this.authService.profile?.salesPhone, this.salesMatchesUser ? null : [Validators.required, Validators.pattern(/^\(\d{3}\) \d{3}-\d{4}$/)]],
                email: [this.authService.profile?.salesEmail, this.salesMatchesUser ? null : [Validators.required, Validators.email]],
            }),
            theaters: this.fb.array([]),
            password: ['', [Validators.required, Validators.minLength(6)]],
            confirmPassword: ['', [Validators.required]]
        }, { validators: passwordMatchValidator });

        if (this.authService.profile?.theaters.length) {
            this.authService.profile?.theaters.forEach(theater => {
                this.addTheater(theater)
            })
        }
    }

    editPersonal() {
        this.initValues()
        this.partInfoOpen = true
    }

    closePersonal() {
        this.partInfoOpen = false
    }


    changePassword() {
        this.partPawwordOpem = true
    }

    closePassword() {
        this.partPawwordOpem = false
    }

    onPasswordChange(value: string) {
        this.passwordStrengthService.setPassword(value);
    }

    savePersonal() {
        this.partInfoOpen = false

        let user = this.registerForm.get('user')?.value
        if (this.authService.profile) {
            this.authService.profile.firstName = user.firstName
            this.authService.profile.lastName = user.lastName
            this.authService.profile.phone = user.phone
            this.authService.profile.email = user.email

            this.authService.saveProfile()
        }
    }

    editSales() {
        this.initValues()
        this.partSalesOpen = true
    }

    closeSales() {
        this.partSalesOpen = false
    }

    saveSales() {
        this.partSalesOpen = false

        let sales = this.registerForm.get('sales')?.value
        if (this.authService.profile) {
            this.authService.profile.salesFirstName = sales.firstName
            this.authService.profile.salesLastName = sales.lastName
            this.authService.profile.salesPhone = sales.phone
            this.authService.profile.salesEmail = sales.email

            this.authService.saveProfile()
        }
    }

    saveTheater() {
        let hasErrors : boolean = false

        this.theaters.controls.forEach((control) => {
            if(control.get('adress')?.errors != null) {
                hasErrors = true
            }
        })
        // if(hasErrors) return


        this.theatersOpen = false
        let theaters = this.registerForm.get('theaters')?.value

        if (this.authService.profile) {
            this.authService.profile.theaters = theaters.map((theater: any) => new Theater(theater))

            this.authService.saveProfile()
        }
        this.editIndex = -1
    }

    // addTheaters() {
    //     this.initValues()

    //     this.addNewTheater()
    //     // this.theatersOpen = true
    // }

    editTheaters() {
        this.initValues()
        if (this.theaters.length == 0) {
            this.addNewTheater()
        }

        this.theatersOpen = true
    }

    closeTheaters() {
        this.theatersOpen = false
    }

    userUpdate() {

    }

    onSubmit() {

    }

    get theaters(): FormArray {
        return this.registerForm.get('theaters') as FormArray;
    }

    addNewTheater(): void {
        // const theaterGroup = this.fb.group({
        //     name: ['', Validators.required],

        //     city: ['', Validators.required],
        //     zip: ['', [Validators.required, Validators.pattern(/^\d{5}$/)]],
        //     adress: ['', Validators.required],
        //     state: ['', Validators.required],

        //     phone: ['', [Validators.required, Validators.pattern(/^\(\d{3}\) \d{3}-\d{4}$/)]],
        //     preferredFormat: ['', Validators.required],
        //     admissionCharges: [false]
        // });
        // this.theaters.push(theaterGroup);

        this.authService.profile?.theaters.unshift(new Theater({}))
        this.initValues()

        this.editIndex = 0
    }

    addTheater(theater: Theater): void {
        const theaterGroup = this.fb.group({
            name: [theater.name, Validators.required],

            city: [theater.city, Validators.required],
            zip: [theater.zip, [Validators.required, Validators.pattern(/^\d{5}$/)]],
            adress: [theater.adress, Validators.required],
            state: [theater.state, Validators.required],

            phone: [theater.phone, [Validators.required, Validators.pattern(/^\(\d{3}\) \d{3}-\d{4}$/)]],
            preferredFormat: [theater.preferredFormat, Validators.required],
            admissionCharges: [theater.admissionCharges]
        });
        this.theaters.push(theaterGroup);
    }

    editTheater(i: number) {
        this.initValues()
        this.editIndex = i
    }

    closeEditTheater() {
        if (this.theaters.controls[this.editIndex].get('name')?.value == '' || this.theaters.controls[this.editIndex].get('name')?.value == null) {
            this.removeTheater(this.editIndex)
        }

        this.editIndex = -1


    }

    removeTheater(index: number): void {
        this.theaters.removeAt(index);
        this.authService.profile?.theaters.splice(index, 1)
        this.saveTheater()
        this.closeEditTheater()
    }

    logout() {
        this.authService.logout()
    }

    savePassword() {
        if (this.registerForm) {
            let password = this.registerForm.get('password')?.value
        

            if (this.authService.profile?.email) {

                this.authService.changePassword(password, this.authService.profile?.email).then(() => {

                    this.snackBar.open('Password saved! ', '+', { duration: 5000 });
                }).catch((e) => {
                    this.snackBar.open('This operation is sensitive and requires recent authentication. Log in again before retrying this request.', '+', {
                        // duration: 5000, 
                        panelClass: ['red-error-snackbar'],
                    });
                })
            }


        }

        this.partPawwordOpem = false
    }

    passwordVisibleToggle() {
        this.isPasswordVisible = !this.isPasswordVisible
    }

    passwordVisibleToggle2() {
        this.isPasswordVisible2 = !this.isPasswordVisible2
    }

    onRePasswordChange(value: string) {
        this.isNextButtonDisabled = true
        if (this.passwordStrength().isValid ) {
            if (this.registerForm.get('password')?.value == this.registerForm.get('confirmPassword')?.value && this.registerForm.get('password')?.value.length > 3) {
                this.isNextButtonDisabled = false
            }
        }
    }

    deleteProfile(profile: Profile) {
        this.authService.deleteProfile(profile)
    }
    
}


